<script lang="ts">
	import type { Device } from 'src/types/Device.ts';
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import RelayAdvancedView from './RelayAdvancedView.svelte';
	import RelayPriorityView from './RelayPriorityView.svelte';
	import { isWallDisplay } from 'src/helpers/interface_helpers';

	export let device: Device;

	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: isMainWallDisplay = isWallDisplay(device?.type) && device?.category === 'relay';
	$: isThermostatEnabled = isMainWallDisplay
		? typeof settings?.['thermostat:0'] !== 'undefined'
		: false;
</script>

{#if isThermostatEnabled}
	<RelayAdvancedView {device} />
{:else}
	<RelayPriorityView {device} />
{/if}
